module.exports = __webpack_public_path__ + "static/Farfetch-938169f4ac767b49551a55d05121f532.png";